import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { useContent } from '@/stores/RootStore';
import { useReveal } from '@/hooks/useReveal';
import Button from '@/components/ui/Button';
import SectionHeader from '@/components/ui/SectionHeader';
import s from './Spotlight.module.scss';

// 주력 제품 — D안 '① 주력 제품' = 두 도메인 대표 제품 dual(안전 체감온도계 / 환경 EVS-G200).
//   2026-09-05 단독(EVS-G200)→dual 재구성. 행 교대(안전 이미지 좌 / 환경 이미지 우). 도메인 태그로 안전=시안·환경=그린 구분.
const Spotlight = observer(() => {
  const { spotlight } = useContent();
  const ref = useReveal<HTMLDivElement>();
  // [2026-09-09 사용자] 주력 제품 클릭 → 관련 페이지 SPA 이동. react-router navigate 라 뒤로가기 시
  //   App.tsx 스크롤 복원(POP)이 동작해 다시 이 '주력 제품' 섹션 위치로 돌아온다. [[evs-back-restores-scroll]]
  const navigate = useNavigate();
  const go = (to?: string) => (e: React.MouseEvent) => { if (!to) return; e.preventDefault(); navigate(to); };
  return (
    <section className={s.section}>
      <div className={s.inner} ref={ref}>
        <SectionHeader title={spotlight.sectionTitle} className="anim-scroll" />
        {spotlight.intro && <p className={`${s.intro} anim-scroll`}>{spotlight.intro}</p>}
        <div className={s.list}>
          {spotlight.products.map((p, i) => (
            <div key={p.key} className={`${s.row} ${i % 2 === 1 ? s.reverse : ''} anim-scroll`}>
              <a href={p.to || '#'} onClick={go(p.to)} className={`${s.media} ${p.imgFit === 'cover' ? s.mediaFull : s.mediaTall} ${p.to ? s.clickable : ''}`} aria-label={`${p.name} 자세히`}>
                {p.image
                  ? <img className={`${s.img} ${p.imgFit === 'cover' ? s.imgCover : ''}`} src={p.image} alt={p.name} loading="lazy" />
                  : <div className="placeholder-box" />}
              </a>
              <div className={s.body}>
                <span className={`${s.domain} ${s[p.key]}`}>{p.domainTag} · {p.domainLabel}</span>
                <h3 className={s.name}>{p.name}</h3>
                <p className={s.sub}>{p.subtitle}</p>
                <p className={s.desc}>{p.description}</p>
                <Button variant="pill" href={p.to || '#'} onClick={go(p.to)}>{p.cta}</Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

export default Spotlight;
